import React, { Component } from "react";
import ReactPlayer from "react-player/file";
import globals from "../globals";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

class GalleryPage extends Component {
  state = {
    time: null,
    streamUrl: null,
    errorAlertShow: false,
  };
  ref = (player) => {
    this.player = player;
  };
  async componentDidMount() {
    const time = new Date().getTime();
    var res = await fetch(`${globals.api_domain}/api/gallery/time`, {
      credentials: "include",
    });
    if (res.status === 200) {
      res.json().then((res) => {
        if (res.time < 0) {
          this.setState({ errorAlertShow: true });
          return;
        }
        this.setState(
          {
            streamUrl: res.m3u8,
          },
          () => {
            var timediff = new Date().getTime() - time;
            this.player.seekTo((res.time + timediff / 2) / 1000);
          }
        );
      });
    } else {
      this.setState({
        streamUrl: null,
      });
    }
  }
  render() {
    return (
      <React.Fragment>
        <Container maxWidth="lg" sx={{}}>
          <Typography variant="h4" sx={{ mt: 2 }} gutterBottom>
            <strong>Gallery</strong>
          </Typography>
          {this.state.errorAlertShow ? (
            <Alert severity="info">
              <AlertTitle>Not ready yet</AlertTitle>
              Gallery will start playing on Aug 7th, 3:30 PM ET.
            </Alert>
          ) : null}
          <ReactPlayer
            ref={this.ref}
            url={this.state.streamUrl}
            playing
            loop
            muted
            volume={0}
            width="100%"
            height="90%"
            controls
            config={{
              file: {
                forceHLS: true,
              },
            }}
          />
        </Container>
      </React.Fragment>
    );
  }
}

export default GalleryPage;
